<!-- //
组件可拖动可调整大小
@auth xuyd
@date 2024-05-04
//-->
<template>
  <DraggableResizable
      ref="refDraggable"
      :w="width"
      :h="height"
      :x="left"
      :y="top"
      :z="zIndex"
      :scale="scale"
      :active="innerActive"
      :prevent-deactivation="preventDeactivation"
      :min-width="10"
      :min-height="10"
      :parent="true"
      :grid="[2, 2]"
      @dragging="handleDrag"
      @activated="handleActivated"
      @deactivated="handleDeactivated"
      @resizing="handleResize"
  >
    <slot ref="refComp"/>
    <div class="draggable-mask" :class="[active ? 'draggable-active' : '']"></div>
  </DraggableResizable>
</template>

<script>
const defaultZIndex = 1;
const activeZIndex = 9999;

export default {
  name: 'WidgetDraggableView',
  data() {
    return {
      innerActive: this.active,
      zIndex: defaultZIndex,
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    // {
    // id: 10, parentId: 1, widgetType: 'C', title: '单行标题', maxUse: 0, icon: 'el-icon-c-scale-to-original'
    // ,widgetName: 'widgetTitle', widgetPack: 'widgetTitle', widgetProps:{viewProps:{}, formProps:{}}
    // },
    widget: {
      type: Object,
      default: () => {
        return {}
      }
    },
    scale: {
      type: [Number, Array],
      default: 1,
    },
    /**
     * 阻止deselect事件
     */
    preventDeactivation: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    active: {
      handler: function (val) {
        // console.log("-----活动状态---->", val)
        this.innerActive = val;
      },
      immediate: true
    }
  },
  computed: {
    width: {
      get() {
        return this.$util.px2num(this.widget.widgetProps.viewProps.width);
      },
      set(val) {
        return this.widget.widgetProps.viewProps.width = val;
      }
    },
    height: {
      get() {
        return this.$util.px2num(this.widget.widgetProps.viewProps.height);
      },
      set(val) {
        return this.widget.widgetProps.viewProps.height = val;
      }
    },
    left: {
      get() {
        return this.$util.px2num(this.widget.widgetProps.viewProps.left);
      },
      set(val) {
        return this.widget.widgetProps.viewProps.left = val;
      }
    },
    top: {
      get() {
        return this.$util.px2num(this.widget.widgetProps.viewProps.top);
      },
      set(val) {
        return this.widget.widgetProps.viewProps.top = val;
      }
    },
  },

  methods: {
    /**
     * 设置活动状态
     * @param active
     */
    setActive(active) {
      // 设置状态
      this.active = active;
    },
    handleResize(left, top, width, height) {
      this.left = left;
      this.top = top;
      this.width = width;
      this.height = height;
      if(this.$refs.refDraggable.$children && this.$refs.refDraggable.$children.length > 0) {
        let refComp = this.$refs.refDraggable.$children[0];
        if(refComp.handleResize) {
          refComp.handleResize({left, top, width, height});
        }
      }
    },
    handleDrag(left, top) {
      this.left = left;
      this.top = top;
    },
    handleActivated() {
      this.zIndex = activeZIndex;
      // this.$emit('onActivated', true);
      // console.log("=======activated=====>", this.widget.widgetTitle, this.active);
    },
    handleDeactivated() {
      this.zIndex = defaultZIndex;
      // this.$emit('onActivated', false);
      // console.log("=======deactivated=====>", this.widget.widgetTitle, this.active);
    },
  }
};
</script>

<style lang="less" scoped>

.draggable-mask {
  width: 100%;
  height: 100%;
  border: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999; // el-carousel活动时候是2、按钮是10
}
.draggable-active {
  cursor: move;
  border: 1px dashed #09f;
  background-color: rgba(115, 170, 229, .2);
}
</style>

